import { Link } from "react-router-dom";
export const VendorNetworkPage = () => {
  return (
    <div className="mx-auto max-w-7xl space-y-16 px-6 pb-20 pt-16 md:px-10">

      {/* HERO */}
      <section>
        <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]">
          Partners
        </p>

        <h1 className="mt-4 text-4xl font-bold md:text-5xl">
          Vendor Network
        </h1>

        <p className="mt-6 max-w-3xl text-[#D9E1E8]/80 text-lg">
          The AI Matters Vendor Network connects trusted recruiting vendors
          and sourcing partners with organizations that require scalable
          hiring support. Our platform enables vendors to participate in
          structured hiring programs while maintaining transparency and
          performance accountability.
        </p>
      </section>


      {/* BENEFITS */}
      <section>

        <h2 className="text-3xl font-bold mb-8">
          Benefits of Joining Our Vendor Network
        </h2>

        <div className="grid gap-6 md:grid-cols-3">

          <div className="glass-panel rounded-xl p-6">
            <h3 className="text-xl font-semibold mb-2">
              Access Enterprise Hiring Programs
            </h3>

            <p className="text-[#D9E1E8]/80">
              Participate in structured hiring initiatives for companies
              scaling their talent acquisition operations.
            </p>
          </div>

          <div className="glass-panel rounded-xl p-6">
            <h3 className="text-xl font-semibold mb-2">
              Transparent Collaboration
            </h3>

            <p className="text-[#D9E1E8]/80">
              Work with hiring teams through a shared platform that enables
              clear communication, candidate tracking, and feedback loops.
            </p>
          </div>

          <div className="glass-panel rounded-xl p-6">
            <h3 className="text-xl font-semibold mb-2">
              Performance-Based Growth
            </h3>

            <p className="text-[#D9E1E8]/80">
              Vendors can build long-term partnerships based on measurable
              hiring outcomes and candidate quality metrics.
            </p>
          </div>

        </div>

      </section>


      {/* COLLABORATION MODEL */}
      <section>

        <h2 className="text-3xl font-bold mb-6">
          How Vendor Collaboration Works
        </h2>

        <p className="max-w-4xl text-[#D9E1E8]/80">
          Vendors within The AI Matters ecosystem collaborate with hiring
          teams through a structured workflow environment. Our platform
          provides visibility into hiring requirements, candidate evaluation
          criteria, and submission processes.
        </p>

        <p className="mt-4 max-w-4xl text-[#D9E1E8]/80">
          AI-powered candidate scoring and analytics help ensure that
          submitted profiles match role requirements while maintaining
          high hiring standards across the network.
        </p>

      </section>


      {/* CTA */}
      <section className="glass-panel rounded-2xl p-10 text-center">

        <h2 className="text-3xl font-bold mb-4">
          Become a Vendor Partner
        </h2>

        <p className="max-w-2xl mx-auto text-[#D9E1E8]/80 mb-6">
          Join our growing ecosystem of recruiting vendors and sourcing
          partners helping organizations build high-performing teams.
        </p>

        <Link
          to="/recruiter-network"
          className="inline-block rounded-full bg-[#2EC4A6] px-8 py-3 font-semibold text-[#071A2C] hover:bg-[#6FE3C1]"
        >
          Apply to Join the Network
        </Link>

      </section>

    </div>
  );
};